// extracted by mini-css-extract-plugin
export default {"pagination":"style_pagination__8boin","previous":"style_previous__SBRki","next":"style_next__IE8oW","numbers":"style_numbers__FlGCC","active":"style_active__UMEB8"};